module.exports = __webpack_public_path__ + "assets/img/title-download-method-cdb15de7.png";